import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import RightSide from './RightSide';
import Footer from './Footer';

import tokenError from '../assets/img/token-error.svg';

import '../assets/css/deposit.scss'

class WrongToken extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    render() {
        const { t } = this.props;
        const { whitemarkTitle, whitemarkFavicon, whitemarkBackground, whitemarkLogo } = this.props;
        
        return (
            <div className="main">
                <Helmet>
                    <title>{whitemarkTitle}</title>
                    {<link rel="shortcut icon" href={whitemarkFavicon} />}
                    <style type="text/css">
                        {`
                            .main {
                                background: url(${whitemarkBackground});
                                background-size: cover;
                            }

                            .main>div.darker{
                                background-color: rgba(32,32,48,0.7);
                                min-height: 100vh;
                            }

                            .logoPrincipal {
                                background-image: url(${whitemarkLogo});
                            }
                        `}
                    </style>
                </Helmet>
                <div className={whitemarkTitle === "LockSelf Files Transfer" ? "darker" : "noDark"}>
                    <div className="container">
                        <div className="row">
                            <div className="mColumn">
                                <div className="logoPrincipal">&nbsp;</div>
                                <div className="bigCard">
                                    <div className="Central">
                                        <div className="errorCard">
                                            <div>
                                                <span>{t("error.oops")}</span>
                                            </div>
                                            <h2>{t("error.badToken")}</h2>
                                            <p>{t("error.badToken2")}</p>
                                            <img className="center" src={tokenError} alt="logo" />
                                        </div>
                                    </div>
                                </div>
                                <Footer />
                            </div>
                        </div>
                        <RightSide transferIsAvailable={false} />
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(WrongToken)
